import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { SupportLine } from "@/components/SupportContact";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Las contraseñas no coinciden."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada. Ya puedes ingresar.");
      navigate("/ingresar");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md fade-in">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <ShieldCheck className="w-7 h-7 text-primary" />
          <span className="font-heading font-extrabold text-xl text-primary">EIM Becas</span>
        </div>
        <div className="bg-white rounded-2xl border border-border p-8">
          <h1 className="text-2xl font-bold mb-4">Nueva contraseña</h1>
          {!token ? (
            <p className="text-muted-foreground">Enlace inválido. <Link to="/recuperar" className="text-primary font-semibold">Solicitar uno nuevo</Link>.</p>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label className="text-sm font-semibold uppercase tracking-wide text-slate-600">Contraseña</Label>
                <Input data-testid="input-password" type="password" className="h-14 text-lg rounded-xl mt-2" value={password}
                  onChange={(e) => setPassword(e.target.value)} required />
              </div>
              <div>
                <Label className="text-sm font-semibold uppercase tracking-wide text-slate-600">Confirmar contraseña</Label>
                <Input data-testid="input-confirm" type="password" className="h-14 text-lg rounded-xl mt-2" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)} required />
              </div>
              <Button type="submit" disabled={loading} className="btn-lift w-full h-14 text-lg rounded-xl" data-testid="btn-reset-submit">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Guardar contraseña"}
              </Button>
            </form>
          )}
        </div>
        <SupportLine className="mt-6" />
      </div>
    </div>
  );
}
